import { useMemo } from "react";
import { toast } from "react-toastify";
import { useAccount } from "wagmi";
import { useWeb3Ts } from "../context/Web3TsContext";
import { useConnect } from "./useConnect";
import { useProvider } from "./useProvider";

export const useAddToken = () => {
 const { connector } = useAccount();
 const { isConnected } = useConnect();
 const { config } = useWeb3Ts();
 const { isWalletConnect, provider } = useProvider();
 const isSupport = useMemo(() => {
  return isConnected && !isWalletConnect;
 }, [isConnected, isWalletConnect]);
 const web3TsConfig = useWeb3Ts();
 const addToken = async () => {
  if (!provider) return;
  try {
   let wasAdded = false;
   if (provider.request) {
    wasAdded = (await provider.request({
     method: "wallet_watchAsset",
     params: {
      type: "ERC20",
      options: {
       address: web3TsConfig.config.mainContract.contractAddress,
       decimals: 18,
       symbol: web3TsConfig.config.mainContract.symbol,
       image: web3TsConfig.config.mainContract.logo,
      },
     },
    })) as boolean;
   } else {
    wasAdded =
     (await connector?.watchAsset?.({
      address: web3TsConfig.config.mainContract.contractAddress,
      decimals: 18,
      symbol: web3TsConfig.config.mainContract.symbol,
      image: web3TsConfig.config.mainContract.logo,
     })) || false;
   }

   if (wasAdded) {
    toast.success(
     config.addToken?.message ||
      "We appreciate your interest! Token import to your wallet has been successfully completed."
    );
   } else {
    toast.error(
     web3TsConfig.config.mainContract.symbol + " Coin has not been added"
    );
   }
  } catch (error) {
   console.error(error);
  }
 };
 return {
  addToken,
  isSupport,
 };
};
